/* eslint-disable */
function save(name, value, days = 15) {
   let expires;
   if (days) {
      const date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
   }
   else {
      expires = '';
   }

   document.cookie = name+"="+value+expires+";path=/";
}

function load(name) {
   const nameEQ = `${name}=`;
   const ca = document.cookie.split(';');
   for(let i=0;i < ca.length;i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
   }
   return null;
}

function remove(name) {
   save(name,"",-1);
}

function uuidv4() {
   if (crypto) {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
         (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
   }
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
   });
}

export default {
   save,
   load,
   remove,
   uuidv4
};
